import { useCallback } from 'react';
import { kpiApi } from '../../services/kpiApi';
import { AgentChat } from '../shared/AgentChat';

export default function KpiChat({
  selectedCompanies,
  onSelectCompany,
  onRemoveCompany,
  onWorkspaceAction,
  onThreadCreated,
  threadId: externalThreadId,
}) {
  const handleCustomEvent = useCallback((eventType, data) => {
    if (eventType === 'workspace_action') {
      const payload = data.data || data;
      if (onWorkspaceAction) onWorkspaceAction(payload);
      return true;
    }
    return false;
  }, [onWorkspaceAction]);

  const buildContext = useCallback((companies, threadId) => ({
    selected_rf_ids: companies.map(c => c.rf_id),
    selected_companies: companies.map(c => ({
      rf_id: c.rf_id, name: c.company_name, source_type: c.source_type,
    })),
    org_id: 'default',
    thread_id: threadId || undefined,
  }), []);

  return (
    <AgentChat
      api={kpiApi}
      agentName="KPI Agent"
      threadId={externalThreadId}
      onThreadCreated={onThreadCreated}
      selectedCompanies={selectedCompanies}
      onSelectCompany={onSelectCompany}
      onRemoveCompany={onRemoveCompany}
      buildContext={buildContext}
      onCustomEvent={handleCustomEvent}
      placeholder="Ask the KPI agent..."
      compact
    />
  );
}
